import { Component, OnInit } from '@angular/core';
import { VentanillaService } from '../services/ventanilla.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ConfirmPopComponent } from 'src/app/components/confirm-pop/confirm-pop.component';
import { AlertPopComponent } from 'src/app/components/alert-pop/alert-pop.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CurpValidator, RFCorCURPValidator } from 'src/app/validators/validator';
import { PopApoyosComponent } from '../components/pop-apoyos/pop-apoyos.component';

@Component({
  selector: 'app-buscar-upaeg',
  templateUrl: './buscar-upaeg.component.html',
  styleUrls: ['./buscar-upaeg.component.css'],
  providers: [VentanillaService]
})
export class BuscarUpaegComponent implements OnInit {
  form: FormGroup;
  public error: boolean;
  public isLoading: boolean;
  public upaegs: any;
  public message: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ventanillaService: VentanillaService,
    public dialog: MatDialog,
    private fb: FormBuilder,
  ) {
    this.error = false;
    this.isLoading = false;
    this.message = 'Indique un CURP o RFC para buscar unidades de producción';
    this.upaegs = false;
    this.form = this.fb.group({
      curpOrRfc: ['', [Validators.required, RFCorCURPValidator]]
    });
  }

  ngOnInit() {
  }

  onSubmit(){
    console.log(this.form.value);
    this.isLoading = true;
    this.error = false;
    this.upaegs = false;
    this.message = 'Buscando información, espere un momento';
    this.ventanillaService.getUpaegsPorCampo(this.form.get('curpOrRfc').value).subscribe(response => {
      console.log(response);
      if(response.status){
        this.error = false;
        this.isLoading = false;
        this.upaegs = response.upaegs;
        if(!response.upaegs){
          this.message = response.message;
        }
      }else{
        this.error = true;
        this.isLoading = false;
        this.message = response.message;
        this.upaegs = false;        
      }
    }, error => {
      console.log(error);
      this.error = true;
      this.isLoading = false;
      this.upaegs = false;
      this.message = 'No se pudo procesar su solicitud en este momento';
    });
  }

  verApoyosDisponibles(id_productor){
    const dialogRef = this.dialog.open(PopApoyosComponent, {
      width: '80%',
      data: {
        id_productor
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(result);
    });

  }
}
